import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { makeTestId } from '../../utils/Declarative';
import { HexColorInputWidget } from './HexColorInputWidget';

export interface CustomColorInputProps {
  color: string;
  onColorSelected: (color: string) => void;
  testId: string;
}

export const CustomColorInput = React.forwardRef<HTMLInputElement, CustomColorInputProps>((props, ref) =>
  <div data-tb-test-id={makeTestId(props.testId, 'CustomColorInput')}>
    <HexColorInputWidget
      color={props.color}
      label={Messages.customColor()}
      inputRef={ref}
      onConfirm={props.onColorSelected}
      testId={props.testId}
    />
  </div>
);
CustomColorInput.displayName = 'CustomColorInput';
